var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1,10c0,4.97,4.03,9,9,9s9-4.03,9-9s-4.03-9-9-9S1,5.03,1,10z M0,10C0,4.48,4.48,0,10,0s10,4.48,10,10 s-4.48,10-10,10S0,15.52,0,10z M14,11.5c0-0.28,0.22-0.5,0.5-0.5s0.5,0.22,0.5,0.5c0,1.93-1.26,3.62-3.1,4.18 C11.21,15.89,10.58,16,10.01,16c-0.58,0-1.22-0.11-1.93-0.33C6.25,15.11,5,13.42,5,11.5C5,11.22,5.22,11,5.5,11S6,11.22,6,11.5 c0,1.48,0.97,2.78,2.38,3.22C9,14.91,9.54,15,10.01,15c0.46,0,0.99-0.09,1.6-0.27C13.03,14.3,14,12.99,14,11.5z M13,9 c-0.55,0-1-0.45-1-1s0.45-1,1-1s1,0.45,1,1S13.55,9,13,9z M7,9C6.45,9,6,8.55,6,8s0.45-1,1-1s1,0.45,1,1S7.55,9,7,9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.627b638c997c88780eac94034578ac6c.svg";
export { ForwardRef as ReactComponent };